import useApollo from '@/plugins/graphql/useApollo'

export default {
  namespaced: true,
  state: {
    notifications: [],
    unReadNotifications: 0,
  },
  mutations: {
    SET_NOTIFICATION(state, payload) {
      state.notifications = payload
    },
    SET_UNREAD_NOTIFICATIONS(state, payload) {
      state.unReadNotifications = payload
    },
  },
  actions: {
    setUnreadNotifications({ commit }, count) {
      commit('SET_UNREAD_NOTIFICATIONS', count)
    },
    async fetchNotifications({ commit, state }, { projectUid, page = 1 }) {
      return new Promise(resolve => {
        useApollo.users.getTaskBoardNotifications({ projectUid, page }).then(res => {
          const { notifications } = res.data.me
          commit('SET_UNREAD_NOTIFICATIONS', res.data.me.unRead.total)

          const oldData = state.notifications?.data || []
          if (page > 1) {
            notifications.data = [...oldData, ...notifications.data]
          }

          commit('SET_NOTIFICATION', notifications)
        }).finally(() => {
          resolve(true)
        })
      })
    },
  },
}
